import { createFileRoute } from '@tanstack/react-router';
import { Badge, Text } from '@mantine/core';
import { IconListDetails } from '@tabler/icons-react';
import { ResourceListPage } from '@/shared/components/ResourceListPage';
import { formatDate } from '@/shared/lib/format';
import type { Denormalized } from '@/shared/api/jsonapi/parser';

interface Reason extends Denormalized { type: 'activity-reasons'; description?: string; isActive?: boolean; createdAt?: string; }

export const Route = createFileRoute('/_app/timesheet/reasons')({ component: () => (
  <ResourceListPage<Reason>
    title=""
    type="activity-reasons"
    columns={[
      { accessorKey: 'description', header: 'Causale' },
      {
        accessorKey: 'isActive',
        header: 'Stato',
        size: 120,
        Cell: ({ cell }) => (
          cell.getValue<boolean>()
            ? <Badge color="green" variant="light">Attiva</Badge>
            : <Badge color="gray" variant="light">Disattiva</Badge>
        ),
      },
      {
        accessorKey: 'createdAt',
        header: 'Creata il',
        enableColumnFilter: false,
        Cell: ({ cell }) => <Text size="sm">{formatDate(cell.getValue<string>())}</Text>,
      },
    ]}
    searchField="description"
    emptyMessage="Nessuna causale"
    emptyDescription="Le causali di attività utilizzabili nel timesheet appariranno qui."
    emptyIcon={IconListDetails}
  />
) });
